import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';

export class EmergencyCodeFix {
  static async fixSpecificCode(code: string = 'S-2JYBAVWZ'): Promise<{
    success: boolean;
    message: string;
    details?: any;
  }> {
    const linkingCodeDocument = await getDoc(doc(db, 'linkingCodes', code));
    if (!linkingCodeDocument.exists()) {
      return {
        success: false,
        message:
          'أداة الإصلاح القديمة لا تنشئ بيانات students عامة. أعد توليد كود ربط من حساب الطالب.',
        details: { code },
      };
    }

    const linkingData = linkingCodeDocument.data();
    const userId = linkingData.userId;
    const userDocument = userId ? await getDoc(doc(db, 'users', userId)) : null;

    return {
      success: Boolean(userDocument?.exists()),
      message: userDocument?.exists()
        ? 'الكود موجود وحساب المستخدم موجود. لا توجد كتابة طارئة مطلوبة.'
        : 'الكود موجود لكن حساب المستخدم غير موجود. لا يتم إنشاء بيانات عمل من العميل.',
      details: { userId, code },
    };
  }

  static async testFixedCode(code: string): Promise<{
    linkingCodeExists: boolean;
    studentExists: boolean;
    userExists: boolean;
    allGood: boolean;
  }> {
    const linkingCodeDocument = await getDoc(doc(db, 'linkingCodes', code));
    const linkingCodeExists = linkingCodeDocument.exists();
    const userId = linkingCodeDocument.data()?.userId;
    const userDocument = userId ? await getDoc(doc(db, 'users', userId)) : null;
    const userExists = Boolean(userDocument?.exists());

    return {
      linkingCodeExists,
      studentExists: false,
      userExists,
      allGood: linkingCodeExists && userExists,
    };
  }
}

if (typeof window !== 'undefined') {
  (window as any).emergencyCodeFix = EmergencyCodeFix;
}

export default EmergencyCodeFix;
